module.exports = __webpack_public_path__ + "static/img/footer_icon_11_zh.5f3e214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_icon_11_zh.png
// module id = fRGu
// module chunks = 34